import http from '@/common/utils/http-common';
import { Department } from '@/types/Department.type';
type GetParams = {
  params: {
    parent?: number;
    excludesId?: string;
    sortKey?: string;
  };
};
class DepartmentService {
  getAll(params?: GetParams) {
    return http.get('/departments', params);
  }

  get(id: string) {
    return http.get(`/departments/${id}`);
  }

  create(data: Department) {
    return http.post('/departments', data);
  }

  update(data: Department, id: any) {
    return http.put(`/departments/${id}`, data);
  }

  delete(id: any) {
    return http.delete(`/departments/${id}`);
  }

  getEmployees(id: number) {
    return http.get(`/departments/${id}/employees`);
  }
}

export default new DepartmentService();
